var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiConversationDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8.99935V7.54102L11.375 3.16602L12.8333 4.62435L8.45833 8.99935H7Z",
    stroke: "#FE815F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 9H2.6263C1.82089 9 1.16797 9.65293 1.16797 10.4583C1.16797 11.2637 1.82089 11.9167 2.6263 11.9167H11",
    stroke: "#FE815F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiConversationDraft);
export default __webpack_public_path__ + "static/media/hi-conversation-draft.31700eb68638c07aaaeaa2c3fe3bed14.svg";
export { ForwardRef as ReactComponent };